export default __webpack_public_path__ + "static/media/smirch.132b5e8f.png";